import React, { FC } from 'react';

import { TabProps } from './CustomerSites.props';
import SitesTable from './SitesTable';

const InactiveSites: FC<TabProps> = (props) => (
  <SitesTable {...props} queryScope="inactive" activeOnly={2} />
);

export default InactiveSites;
